import { Component, Input } from "@angular/core";
import { RefundBaseComponent } from "./refund-base.component";
import * as _ from "lodash";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { RefundActionTypeEnum } from "../../_models";
import { SessionManagerService } from "../../_services/SessionManager/session-manager.service";
import { DataService } from "../../_services/data.service";
import { AlertService } from "../../_services/alert.service";

@Component({
  moduleId: module.id,
  selector: "refund-inline",
  templateUrl: "refund-inline.component.html",
  styleUrls: ["./refund-inline.component.css", "./refund-base.component.scss"],
})
export class RefundInlineComponent extends RefundBaseComponent {
  @Input() paymentResult: any;
  modalReference: any;
  enableRefundTypeSelect = false;

  constructor(
    public dataService: DataService,
    public alertService: AlertService,
    private modalService: NgbModal,
    public sessionManager: SessionManagerService
  ) {
    super(dataService, sessionManager);
  }

  onSuccess(message) {
    this.alertService.success(message, true);
  }

  onFailed(message) {
    this.alertService.error(message, true);
  }

  run() {
    super.run();
    this.formGroupConfirmObj = new FormGroup({
      refundAdminCode: new FormControl(null, Validators.required),
      refundType: new FormControl(
        this.paymentResult.refundTypes &&
        this.paymentResult.refundTypes.length > 0
          ? this.paymentResult.refundTypes[0]
          : null,
        Validators.required
      ),
      cancelParticipation: new FormControl(true, Validators.required),
    });
    if (this.formGroupObj.controls["amount"]) {
      this.formGroupObj.controls["amount"].patchValue(
        this.paymentResult.returnAmount
      );
    }
  }

  openModal(content) {
    if (this.modalReference) {
      this.modalReference.close();
    }
    const options: NgbModalOptions = {
      windowClass: "refund-multiple",
      backdrop: "static",
    };
    const hasAllCountiesPermission = !_.isEmpty(
      this.base.user.counties.filter((county) => county.countyId === 1)
    );
    if (
      this.formGroupObj.value.status === RefundActionTypeEnum.APPROVE &&
      hasAllCountiesPermission
    ) {
      this.formGroupConfirmObj.controls["refundType"].setValidators([
        Validators.required,
      ]);
      this.enableRefundTypeSelect = true;
    } else {
      this.formGroupConfirmObj.controls["refundType"].setValidators([]);
      this.enableRefundTypeSelect = false;
    }
    this.modalReference = this.modalService.open(content, options);
  }

  submitForm(content) {
    if (
      this.base.user.hasRefundCode &&
      this.formGroupObj.getRawValue().status !== "COMMENT"
    ) {
      this.openModal(content);
    } else {
      this.submitFormAction(false);
    }
  }

  positiveNum(number: number): number {
    return Math.abs(number);
  }

  submitFormAction(isAdmin) {
    const postData = _.merge(
      {
        paymentReturn: this.paymentResult.returnId,
        itemId: this.paymentResult.itemId || this.paymentResult.id,
      },
      this.formGroupObj.getRawValue(),
      isAdmin ? this.formGroupConfirmObj.getRawValue() : {}
    );
    if (this.modalReference) {
      this.modalReference.close();
    }
    this.submit(postData);
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/payments_refunds/refund-inline.component.ts